import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface VtToastMessage {
  type: 'success' | 'error' ;
  title: string;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class VtToasterService {

  constructor() { }

  private readonly vtToastMessagesSubject = new BehaviorSubject<VtToastMessage[]>([]);
  vtToastMessages$ = this.vtToastMessagesSubject.asObservable();

  success(message: string, title: string, timeout?: number) {

    const currentMessage = this.vtToastMessagesSubject.getValue();
    const vtToastMessage: VtToastMessage = {text: message, title: title, type: 'success'}
    this.vtToastMessagesSubject.next([...currentMessage, vtToastMessage]);

    if(timeout && timeout > 0) setTimeout(() => this.removeToast(vtToastMessage), timeout);
  }

  error(message: string, title: string, timeout?: number) {

    const currentMessage = this.vtToastMessagesSubject.getValue();
    const vtToastMessage: VtToastMessage = {text: message, title: title, type: 'error'}
    this.vtToastMessagesSubject.next([...currentMessage, vtToastMessage]);
    if(timeout && timeout > 0) setTimeout(() => this.removeToast(vtToastMessage), timeout);
  }

  public removeToast(message: VtToastMessage) {

    const updatedMessage = this.vtToastMessagesSubject.value.filter(m => m !== message);
    this.vtToastMessagesSubject.next(updatedMessage);
  }
}
